<div class="popup">
    <form aria-labelledby="title">
        <h2>Выберите, какие товары добавить в корзину</h2>

        @if (cartProductList.length == 0) {
            <div class="absent-products">
                <h6>Не удалось найти позиции</h6>
            </div>
        }

        @if (absentProductList.length) {
            <div class="absent-products">
                <h6>Не удалось найти позиции</h6>
                @for(product of absentProductList; track $index){
                    <div>{{product.header}}</div>
                }
            </div>
        }

      @if (requestedProductList.length) {
        <div class="requested-products">
          <h6>Товары по запросу не будут добавлены в корзину. Запросите их через функционал <a (click)="close()" [routerLink]="['/cabinet/orders/requested-products']">Товары по запросу</a></h6>
          @for(product of requestedProductList; track $index){
            <div>{{product.header}}</div>
          }
        </div>
      }

        @if (0 < existsProductList.length) {
            <div class="exists-products">
                <h6>Добавить товары в корзину</h6>

                <app-import-list [cartProductList]="existsProductList" (onDelete)="delete($event)" (onSelect)="select($event)" />

                <div class="summ-specification">

                    <p class="summ" i18n="@@TotalByInvoice">
                        <span class="label">Итого:</span>
                        <span class="price-main">{{ (totalCost | formatPriceNumber).main }}</span>
                        <span class="price-cents">.{{ (totalCost | formatPriceNumber).cents }}</span>
                        <span class="curr">₽</span>
                    </p>
                    <p class="summ-vat" i18n="@@TotalByInvoiceVat">
                        <span class="label">Итого с НДС:</span>
                        <span class="price-main">{{ (totalCostVat | formatPriceNumber).main }}</span>
                        <span class="price-cents">.{{ (totalCostVat | formatPriceNumber).cents }}</span>
                        <span class="curr">₽</span>
                    </p>
                </div>
            </div>

            <nb-card-footer>
                @if (existsProductList && existsProductList.length > 0) {
                    <button type="button"
                            size="large"
                            class="btn-primary"
                            nbSpinnerStatus="control"
                            (click)="send()"
                            i18n="@@AddProducts"
                            [nbSpinner]="submitted"
                            [disabled]="selected.size === 0 || submitted">
                        Добавить товары
                    </button>
                }

                <button nbButton i18n="@@Cancel"
                        class="btn-light-gray"
                        type="button" (click)="close()" size="large">
                    Отмена
                </button>
            </nb-card-footer>
        }
    </form>
</div>
